import { ConnectedPosition } from "@angular/cdk/overlay";

/**
 * CDK connected-overlay positions for panels that hang below a trigger and flip
 * above when there isn't room. Shared by the date field and the dropdown components
 * so the five identical copies don't drift.
 */
export const CONNECTED_OVERLAY_POSITIONS_BELOW: ConnectedPosition[] = [
  { originX: "start", originY: "bottom", overlayX: "start", overlayY: "top", offsetY: 4 },
  { originX: "start", originY: "top", overlayX: "start", overlayY: "bottom", offsetY: -4 },
];
